import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IPayzenTransporterConfiguration } from '../models/payzen-transporter-configuration';
import { ITransportConfigurationService } from './i-transport-configuration.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';

@Injectable({ providedIn: 'root' })
export class PayzenTransporterConfigurationService implements ITransportConfigurationService<IPayzenTransporterConfiguration> {
  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  constructor(protected apiProvider: ApiProviderService) {}

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<IPayzenTransporterConfiguration>> {
    return this.apiProvider.publicGet<IPayzenTransporterConfiguration>(this.publicResourceUrl('payzen', transporterId), { observe: 'response' });
  }

  canAddIncident(transportOrderId: number): Observable<HttpResponse<boolean>> {
    return this.apiProvider.publicGet<boolean>(this.publicResourceUrl('payzen') + `/canAddIncident/${transportOrderId}`, { observe: 'response' });
  }

  updateConfiguration(configuration: IPayzenTransporterConfiguration, transporterId?: number): Observable<HttpResponse<IPayzenTransporterConfiguration>> {
    return this.apiProvider.configurationPut<IPayzenTransporterConfiguration>(this.moderatorResourceUrl('payzen', transporterId), configuration);
  }
}
